module.exports = __webpack_public_path__ + "static/media/E_lean1.31b32163.png";